import Vue from 'vue'
import locationStore from './locationStore'
import { getPermissions, getHomePath } from '../utils/permissions.mjs'
import { readSession, saveSession, clearSession } from '../utils/session.mjs'

const state = Vue.observable(readSession(sessionStorage))

export default {
  state,
  get permissions() {
    return getPermissions(state)
  },
  get homePath() {
    return getHomePath(state)
  },
  login(data, fallbackName) {
    const session = saveSession(sessionStorage, data, fallbackName)
    locationStore.clear()
    Object.assign(state, session)
  },
  logout() {
    clearSession(sessionStorage)
    locationStore.clear()
    Object.assign(state, readSession(sessionStorage))
  }
}
